import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      toast.error("Passwords don't match");
      return;
    }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      toast.success("Password updated — sign in with your new password");
      navigate("/login");
    } catch (e2) {
      toast.error(formatApiError(e2.response?.data?.detail) || "Reset failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F7F5F0] flex items-center justify-center p-8">
      <div className="w-full max-w-md">
        <span className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#6C7565]">Account recovery</span>
        <h2 className="font-serif text-4xl lg:text-5xl mt-2 mb-8 tracking-tight">Set a new password.</h2>

        {!token ? (
          <div className="border-2 border-[#D94F3D] bg-white p-8" data-testid="reset-no-token">
            <p className="font-serif text-xl">This reset link is incomplete. Please use the link from your email, or request a new one.</p>
            <Link to="/forgot-password" className="inline-block mt-4 text-sm underline underline-offset-4 hover:text-[#A67C00]">Request a new link →</Link>
          </div>
        ) : (
          <form onSubmit={submit} data-testid="reset-password-form">
            <label className="block mb-6">
              <span className="font-mono text-[10px] tracking-widest uppercase text-[#6C7565] block mb-2">New password</span>
              <input
                type="password"
                required
                minLength={6}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="reset-password-input"
                className="w-full bg-transparent border-0 border-b border-[#1A1F16] py-2 text-lg focus:outline-none focus:border-[#A67C00]"
                placeholder="At least 6 characters"
              />
            </label>
            <label className="block mb-8">
              <span className="font-mono text-[10px] tracking-widest uppercase text-[#6C7565] block mb-2">Confirm password</span>
              <input
                type="password"
                required
                minLength={6}
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                data-testid="reset-confirm-input"
                className="w-full bg-transparent border-0 border-b border-[#1A1F16] py-2 text-lg focus:outline-none focus:border-[#A67C00]"
                placeholder="Repeat the password"
              />
            </label>
            <button
              type="submit"
              disabled={busy}
              data-testid="reset-submit-btn"
              className="w-full bg-[#1A1F16] text-[#F7F5F0] py-4 uppercase tracking-[0.25em] text-xs hover:bg-[#2C3628] disabled:opacity-50 transition-colors"
            >
              {busy ? "Updating…" : "Update password"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
